export default __webpack_public_path__ + "static/media/mundzugang.83b2ddc0.png";